import { type UseQueryResult, useQuery } from 'react-query';
import {
  EsppOfferingPeriodService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodRow,
} from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetOfferingPeriodDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_EsppDtos_EsppOfferingPeriodDtos_EsppOfferingPeriodRow | undefined,
  unknown
> => {
  const offeringPeriodDetails = useQuery(['getOfferingPeriodDetails'], async () => {
    if (id) {
      return await handleRequest(EsppOfferingPeriodService.getApiAwardApiAwardOfferingPeriod1(id));
    }
  });

  return offeringPeriodDetails;
};

export default useGetOfferingPeriodDetails;
